import { render, staticRenderFns } from "./StatusProdutoAutocomplete.vue?vue&type=template&id=08a7e5e1"
import script from "./StatusProdutoAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusProdutoAutocomplete.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports